import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { SwUpdate } from "@angular/service-worker";
import { APP_UPDATE_PENDING_KEY } from './constants/app-update.constants';

const createHost = require("cross-domain-storage/host");

declare var jasmine;

@Component({
  selector: "mandae-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  constructor(
    private swUpdate: SwUpdate,
    private snackBar: MatSnackBar
  ) {}

  public ngOnInit(): void {
    // Detectar e notificar sobre novas versões
    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(() => {
        // Gravar flag imediatamente quando nova versão for detectada
        localStorage.setItem(APP_UPDATE_PENDING_KEY, 'true');

        // Mostrar snackbar para usuário decidir quando atualizar
        this.snackBar
          .open("Há uma atualização disponível", "Atualizar", {
            duration: 0,
          })
          .onAction()
          .subscribe(async () => {
            // Limpar flag antes de recarregar (evita reload duplo)
            localStorage.removeItem(APP_UPDATE_PENDING_KEY);

            await this.swUpdate.activateUpdate();
            window.location.reload();
          });
      });
    }

    if (typeof window !== "undefined" && typeof jasmine === "undefined") {
      /* tslint:disable:no-trailing-whitespace */
      console.log(`                  ▄
               ▄▞▀▄
            ▄▞▀▄▞▀▄
   ▄▞▀   ▄▞▀▄▞▀▄▞▀▄
▄▞▀▄▞▀▄▞▀▄▞▀▄▞▀▄▞▀▄
▄▞▀▄▞▀▄▞▀▄▞▀▄▞▀▄▞▀▄
▄▞▀▄▞▀▄▞▀▄▞▀▄▞▀▄▞▀
▄▞▀   ▄▞▀   ▄▞▀

Copyright (c) Mandaê 2026
`);
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.get('plataforma') === 'nuvemshop') {
      sessionStorage.setItem('webapp.plataforma', queryString);
    }
  }
}
